import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Designers } from 'apps/find-designers/propTypes';

import FeaturedSearchItem from './FeaturedSearchItem';

function FeaturedSearch({ search, onClick }) {
    return (
        <div className="featured-search">
            <div className="featured-search__header">
                <div className="feature-search-header">
                    <div className="featured-search-header__heading">
                        <h4 className="heading heading--h4 heading--no-margin">{search.title}</h4>
                    </div>
                    <div className="featured-search-header__see-all">
                        <Link
                            className="link link--cta link--jumbo"
                            to={search.searchUrl}
                            onClick={onClick}
                        >
                            <FormattedMessage id="see_all_results_link" />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="featured-search__results">
                <div
                    className={`
                        matrix
                        matrix--of-three-large
                        matrix--of-three-normal
                        matrix--of-three-medium
                        matrix--of-one-small
                    `}
                >
                    {search.designers.map(designer => (
                        <div className="matrix__item" key={designer.id}>
                            <FeaturedSearchItem designer={designer} />
                        </div>
                    ))}
                </div>
            </div>
            <div className="featured-search__footer">
                <div className="feature-search-footer">
                    <div className="featured-search-footer__see-all">
                        <a
                            className="link link--cta link--jumbo"
                            href={search.searchUrl}
                            onClick={onClick}
                        >
                            <FormattedMessage id="see_all_results_link" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

FeaturedSearch.propTypes = {
    search: PropTypes.shape({
        title: PropTypes.string.isRequired,
        searchUrl: PropTypes.string.isRequired,
        designers: Designers.isRequired,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default FeaturedSearch;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/FeaturedSearch.jsx